// Tools of booking module

import { BookingCommonUser, BookingProfessional } from "./booking.dto";
import { BOOKING_USER_TYPE } from "./booking.types";

/** */
export function isProfessional<T extends BookingProfessional = BookingProfessional>(user: BookingCommonUser): user is T {
    return (user as BookingProfessional).advertisement != null && (user as BookingProfessional).bookingType === BOOKING_USER_TYPE.PROFESSIONAL;
}